import firebase from "firebase/app";

export const withPagination = async <T, P>(
  query: (params?: P) => firebase.firestore.Query<T>,
  document: (param: string) => firebase.firestore.DocumentReference<T>,
  params?: P & { limit?: number; prev?: string; next?: string },
): Promise<firebase.firestore.Query<T>> => {
  let collectionRef = query(params);

  if (params?.prev) {
    const orderFirstDocument = await document(params.prev).get();
    collectionRef = collectionRef.endBefore(orderFirstDocument);
  }

  if (params?.next) {
    const orderLastDocument = await document(params.next).get();
    collectionRef = collectionRef.startAfter(orderLastDocument);
  }

  if (params?.limit) {
    collectionRef = params.prev ? collectionRef.limitToLast(params.limit) : collectionRef.limit(params.limit);
  }

  return collectionRef;
};
